var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.f273ca754d5b7e659fcb764c70d93993.svg#M';
                    var viewUrl = 'sprites.f273ca754d5b7e659fcb764c70d93993.svg#view-M';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 48 48',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };